module.exports = __webpack_public_path__ + "img/item_1.77e8db1d.png";